module.exports = __webpack_public_path__ + "files/cfc8cdd728cc78f4d72b68b0686da7bb.png";